import { useMemo } from 'react';
import { InterviewItem } from '../types';
import { applyTemplate } from '../utils/offerUtils';

export const useOfferGeneration = (
  candidates: InterviewItem[],
  formValues: any,
  htmlTemplate: string,
  jobTitle?: string
) => {
  const offersPreview = useMemo(() => {
    if (!formValues || candidates.length === 0) return [];

    return candidates.map((candidate) => {
      const offerDetails = {
        ...formValues,
        candidateName: candidate.name || formValues.candidateName || '',
        candidate_name: candidate.name || formValues.candidate_name || '',
        full_name: candidate.name || formValues.full_name || '',
        name: candidate.name || formValues.name || '',
        jobTitle: jobTitle || formValues.jobTitle || '',
        job_title: jobTitle || formValues.job_title || formValues.jobTitle || '',
        issueDate: new Date().toISOString().split('T')[0],
      };

      const monthlySalaryRaw = Number(
        offerDetails.monthlySalary ?? offerDetails.salary_monthly
      );
      const monthlySalary = Number.isFinite(monthlySalaryRaw) ? monthlySalaryRaw : null;

      const placement_fees =
        monthlySalary !== null && monthlySalary > 0
          ? Math.max(2500, monthlySalary * 0.1).toFixed(2)
          : '';

      const formattedMonthlySalary = monthlySalary !== null ? monthlySalary.toFixed(2) : '';

      const extendedOfferDetails = {
        ...offerDetails,
        monthlySalary: formattedMonthlySalary,
        salary_monthly: formattedMonthlySalary || String(offerDetails.salary_monthly ?? ''),
        joining_date: offerDetails.joining_date ?? '',
        bond_period: offerDetails.bond_period ?? '',
        bond_clause: offerDetails.bond_clause ?? '',
        placement_fees,
        placementFee: placement_fees, // for fee_amount in submit payload
      };
      const offerLetterHtml = applyTemplate(htmlTemplate, extendedOfferDetails);


      return {
        candidateId: candidate.id,
        offerDetails: extendedOfferDetails,
        offerLetterHtml,
      };
    });
  }, [candidates, formValues, htmlTemplate, jobTitle]);

  return offersPreview;
};
